// Paleta de cores do redesign do fluxo do participante (usuário final).
// Extraída dos mockups em "UXUI Design Associacao". Não é um tema do MUI —
// é usada via sx/style diretamente pelas páginas do participante, para não
// mexer no ThemeProvider global (que também serve o painel admin).

export const participantColors = {
  fontFamily: "'Plus Jakarta Sans', 'Helvetica Neue', sans-serif",

  bg: '#f2f8f2',
  bgGradientTop: '#eaf6ea',
  surface: '#ffffff',
  surfaceDark: '#063f10',
  surfaceHover: '#f4faf4',
  surfaceTint: '#eef7ee',

  textDarkest: '#0d3512',
  textBase: '#143d18',
  textSecondary: '#3e6843',
  textTertiary: '#6d9370',
  textFaint: '#8fac92',
  iconMuted: '#b9d3bb',

  onDarkPrimary: '#ffffff',
  onDarkSecondary: '#d8f0d8',
  onDarkMuted: '#b9dcb9',
  onDarkAccent: '#7fd88a',

  brandDark: '#006414',
  brandMid: '#009929',
  brandLight: '#5ccb5f',
  brandIcon: '#4d7a52',
  successText: '#1d5a24',

  border: '#dcecdc',
  borderHover: '#b9dcb9',
  borderModalRow: '#e4f0e4',

  amber: '#f5b01b',
  amberBg: '#fdf4dd',
  amberTextDark: '#8a6104',
  amberTextDarker: '#6e4d02',

  error: '#c62828',
  errorBorder: '#e5a5a0',
  errorBg: '#fdf3f2',
  errorTextDark: '#a52620',
  errorHover: '#b02323',
  errorBorderSoft: '#f3c6c2',

  infoBg: '#e8f0f8',
  infoText: '#1a5089',
  infoStubBg: '#f2f5f8',
  infoStubIcon: '#7d97ad',

  confetti: ['#009929', '#5ccb5f', '#f5b01b', '#1a6fc4', '#ebed17'],

  scrim: 'rgba(10,35,14,0.55)',

  gradients: {
    pageBg: 'linear-gradient(180deg, #eaf6ea 0%, #f2f8f2 380px)',
    primaryButton: 'linear-gradient(135deg, #006414, #009929)',
    successBadge: 'linear-gradient(135deg, #009929, #5ccb5f)',
  },

  shadows: {
    tight: '0 2px 10px rgba(20,61,24,0.08)',
    card: '0 4px 24px rgba(20,61,24,0.08)',
    listItem: '0 3px 16px rgba(20,61,24,0.06)',
    secondaryCard: '0 4px 20px rgba(20,61,24,0.07)',
    loginCard: '0 8px 32px rgba(20,61,24,0.1)',
    primaryButton: '0 8px 24px rgba(0,100,20,0.3)',
    darkHero: '0 6px 24px rgba(6,63,16,0.25)',
    darkHeroLarge: '0 8px 30px rgba(6,63,16,0.3)',
    successBadge: '0 10px 30px rgba(0,153,41,0.35)',
  },

  radius: {
    pill: 999,
    button: 16,
    input: 14,
    tile: 16,
    card: 20,
    cardLarge: 24,
    sheetTop: '24px 24px 0 0',
  },
} as const;

// Variantes de status usadas em chips/badges (cupom, campanha, sorteio).
export const statusVariants = {
  success: { bg: participantColors.surfaceTint, text: participantColors.successText },
  amber: { bg: participantColors.amberBg, text: participantColors.amberTextDark },
  info: { bg: participantColors.infoBg, text: participantColors.infoText },
  error: { bg: participantColors.errorBg, text: participantColors.error },
} as const;

export const fadeUpKeyframes = `
@keyframes participantFadeUp {
  0% { transform: translateY(14px); opacity: 0; }
  100% { transform: translateY(0); opacity: 1; }
}
`;
